import React, { forwardRef } from 'react';
import styles from './styleConstants.module.css';

export { H2Large } from '../home/styleConstants';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

type HeadingProps = React.ComponentPropsWithoutRef<'h1'>;
type Heading2Props = React.ComponentPropsWithoutRef<'h2'>;
type Heading3Props = React.ComponentPropsWithoutRef<'h3'>;
type DivProps = React.ComponentPropsWithoutRef<'div'>;

export const H1 = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h1 ref={ref} className={cx(styles.h1, className)} {...rest} />
  ),
);
H1.displayName = 'H1';

// `as` mirrors styled-components' tag override: keeps H2's styling on a
// different heading level (buy pages need the section title to be the h1).
export const H2 = forwardRef<
  HTMLHeadingElement,
  Heading2Props & { as?: 'h1' | 'h2' }
>(({ className, as: Tag = 'h2', ...rest }, ref) => (
  <Tag ref={ref} className={cx(styles.h2, className)} {...rest} />
));
H2.displayName = 'H2';

export const titleH = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...rest }, ref) => (
    <h1 ref={ref} className={cx(styles.titleH, className)} {...rest} />
  ),
);
titleH.displayName = 'titleH';

export const H3 = forwardRef<HTMLHeadingElement, Heading3Props>(
  ({ className, ...rest }, ref) => (
    <h3 ref={ref} className={cx(styles.h3, className)} {...rest} />
  ),
);
H3.displayName = 'H3';

export const FadeInText = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...rest }, ref) => (
    <div ref={ref} className={cx(styles.fadeInText, className)} {...rest} />
  ),
);
FadeInText.displayName = 'FadeInText';
